export default {
  title: {
    en: 'It’s the holiday season!',
  },
  button: {
    en: 'Shop now',
  },
}
